import React from 'react';
import type { TypeCompany } from '@/types/company/types.company';

export const CompanyContext = React.createContext<TypeCompany | null>(null);
